export default __webpack_public_path__ + "static/media/fire-extinguisher.0e592945.svg";